import { useState, useCallback } from "react";
import { formatPhone } from "./phone";

// Управляет значением телефона с маской +7 (___) ___-__-__.
// Возвращает пропсы для <input>: value + onChange (+onFocus для автоподстановки +7).
export default function usePhoneMask() {
  const [value, setValue] = useState("");

  const onChange = useCallback((e) => {
    setValue(formatPhone(e.target.value));
  }, []);

  const onFocus = useCallback(() => {
    setValue((v) => (v ? v : "+7 ("));
  }, []);

  const reset = useCallback(() => setValue(""), []);

  return { value, onChange, onFocus, reset, setValue };
}
